import { useEffect, useRef } from 'react';
import { getApiUrl } from '../utils/api';

const useAppVersionsEvents = (onUpdate) => {
    const eventSourceRef = useRef(null);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) return;

        const eventSource = new EventSource(
            `${getApiUrl('/api/app-versions/events')}?token=${token}`
        );
        eventSourceRef.current = eventSource;

        eventSource.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                
                if (data.type === 'appVersionsUpdate' && onUpdate) {
                    onUpdate(data.data);
                }
            } catch (error) {
                console.error('Error parsing SSE message:', error);
            }
        };

        eventSource.onerror = (error) => {
            console.error('SSE connection error:', error);
            eventSource.close();
        };

        return () => {
            if (eventSourceRef.current) {
                eventSourceRef.current.close();
            }
        };
    }, [onUpdate]);

    return eventSourceRef.current;
};

export default useAppVersionsEvents; 